"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _notification = _interopRequireDefault(require("cccisd-icons/notification"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var RenderSmsMessage = function RenderSmsMessage(_ref) {
  var messageInfo = _ref.messageInfo,
    sentAt = _ref.sentAt,
    status = _ref.status,
    messageResponse = _ref.messageResponse;
  var dateClass = _style["default"].date;
  var messageClass = _style["default"].fromThem;
  var okStatuses = ['sent', 'logonly.sent', 'enqueued', 'SUCCESS'];
  if (!okStatuses.includes(status)) {
    messageClass += ' ' + _style["default"].messageDisabled;
  }
  var errorIcon = false;
  var statusMessage = status[0].toUpperCase() + status.substring(1);
  switch (status) {
    case 'SUCCESS':
      statusMessage = 'Delivered';
      break;
    case 'FAILURE':
    case 'failed':
      errorIcon = true;
      statusMessage = 'Not Delivered' + (messageResponse !== null ? ': ' + messageResponse : '');
      break;
    default:
      statusMessage = status[0].toUpperCase() + status.substring(1);
      break;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].phone
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].chat
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].messages
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(_style["default"].toNumber, 'text-primary')
  }, "To: ", messageInfo.to), /*#__PURE__*/_react["default"].createElement("div", {
    className: dateClass
  }, sentAt), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'block'
    }
  }, errorIcon && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      "float": 'left',
      color: '#ff3333',
      position: 'relative',
      top: '10px',
      paddingRight: '5px'
    }
  }, /*#__PURE__*/_react["default"].createElement(_notification["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: messageClass
  }, messageInfo.body)), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(_style["default"].smsStatus),
    style: {
      color: errorIcon ? '#ff3333' : 'inherit'
    }
  }, statusMessage))));
};
var _default = exports["default"] = RenderSmsMessage;